import React,{useState, useEffect} from 'react';
import {Link, useNavigate, useParams} from "react-router-dom";
import { FormControl, TextField, Typography, Box, InputLabel, OutlinedInput, InputAdornment, IconButton } from '@mui/material';
import logo from '../../Components/assets/images/logo.png';
import {toast } from 'react-toastify';
import { BaseUrl ,Reset_Password,Signin } from '../../services/Url';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

function ResetPassword(props){
	const navigate = useNavigate();
	const auth = localStorage.getItem('token');
	const [pwd, setPwd] = useState("");
	const [confirmPwd, setConfirmPwd] = useState("");
	const [showPassword, setShowPassword] = useState(false);
	const params = useParams();
	const submit = async (e) => {
		e.preventDefault();
		if(pwd != confirmPwd){
			toast.error('Password and Confirm Password are not matched')
		}
		else{
			restApi();			
		}
	}

	useEffect(() => {
		if(auth){
			navigate('/');
		}
	}, [auth]);

	const restApi = () => {
		fetch(`${BaseUrl + Reset_Password}`,{
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ 
				"forgot_token" : params?.tokenId,
				"password" : pwd
			 })
		})
		.then(async response => {
			const data = await response.json();
			if (response?.status === 200) {
				toast.success(data.message);			
				navigate('/');
			}
			else{
				toast.error(data.message);
			}
		})
		.catch(error => {
			toast.error(error);
		});
	}
	const handleClickShowPassword = () => setShowPassword((show) => !show);
  
	const handleMouseDownPassword = (event) => {
	  event.preventDefault();
	};
	
	
	return (
		<Box className='lgn_mdl_wpr'>
		<form
			onSubmit={submit}
			className="lgn_mdl"
			style={{

				width: " 500px ",
				margin: '0 auto',
				padding: "30px"
			}}
		>
			<Box>
			<div className='logo'>
				<img src={logo} alt='popular' loading='lazy'  />
			</div>
			<Typography variant='h4' marginBottom={4}>
				 Reset Password
			</Typography>
			<Box display='flex' width='100%' flexDirection='column' gap={2} marginBottom={4}>				
			<FormControl variant="outlined">
				<InputLabel htmlFor="outlined-adornment-password">New Password</InputLabel>
				<OutlinedInput
					id="outlined-adornment-password"
					onChange={(e) => setPwd(e.target.value)}
					type={showPassword ? 'text' : 'password'}
					endAdornment={
					<InputAdornment position="end">
						<IconButton
						aria-label="toggle password visibility"
						onClick={handleClickShowPassword}
						onMouseDown={handleMouseDownPassword}
						
						edge="end"
						>
						{showPassword ? <VisibilityOff /> : <Visibility />}
						</IconButton>
					</InputAdornment>
					}
					label="Password"
				/>
		</FormControl>
				<FormControl variant="outlined">
						<InputLabel htmlFor="outlined-adornment-password">Confirm Password</InputLabel>
						<OutlinedInput
							id="outlined-adornment-password"
							type={showPassword ? 'text' : 'password'}
							onChange={(e) => setConfirmPwd(e.target.value)}
							endAdornment={
							<InputAdornment position="end">
								<IconButton
								aria-label="toggle password visibility"
								onClick={handleClickShowPassword}
								onMouseDown={handleMouseDownPassword}
								edge="end"
								>
								{showPassword ? <VisibilityOff /> : <Visibility />}
								</IconButton>
							</InputAdornment>
							}
							label="Password"
						/>
        		</FormControl>
			</Box>
			<Link  to="/" onClick={(e) => submit(e)} className='fluid_btn'>
				Submit
			</Link>
			</Box>
		</form>
		</Box>
	);
}

export default ResetPassword;